import { defineStyleConfig, defineStyle } from "@chakra-ui/react";

const baseStyle = defineStyle({
  content: defineStyle({
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
  })
})

export const Popover=  defineStyleConfig({
  baseStyle,
})